/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { AnimateSharedLayout, motion } from "framer-motion";
import React from "react";
import { notSelect } from "../../../../styles/general";

const Container = styled.div`
  min-width: 557px;
  max-width: 557px;
  min-height: 38px;
  max-height: 38px;

  margin: 20px;

  background-color: #f4f4f4;
  border-radius: 5px;
  color: #1b1b1b;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  transform: "translateZ(0)";

  position: relative;

  @media screen and (max-width: 600px) {
    min-width: 360px;
    max-width: 360px;
  }
`;

const TitleOne = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  position: absolute;
  top: 10px;
  left: 64px;
  cursor: pointer;
  ${notSelect}

  @media screen and (max-width: 600px) {
    left: 32px;
  }
`;

const TitleTwo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  position: absolute;
  top: 10px;
  right: 255px;
  cursor: pointer;
  ${notSelect}

  @media screen and (max-width: 600px) {
    right: 154px;
  }
`;

const TitleThree = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  position: absolute;
  top: 10px;
  right: 53px;
  cursor: pointer;
  ${notSelect}

  @media screen and (max-width: 600px) {
    right: 19px;
  }
`;

const GENERAL = 0;
const FOOTER = 1;
const SEND_FROM = 2;

interface Props {
  selected: number;
  handleSelected: (screen: number) => void;
}
export default function Tab(props: Props): JSX.Element {
  const screens = [GENERAL, FOOTER, SEND_FROM];
  const { selected, handleSelected } = props;

  return (
    <AnimateSharedLayout>
      <Container>
        {screens.map((screen) => (
          <motion.div
            key={screen}
            css={css`
              margin: 0;
              position: relative;
              cursor: pointer;
            `}
            animate
            onClick={() => handleSelected(screen)}
          >
            {screen === selected && (
              <motion.div
                layoutId="underline"
                className="underline"
                css={css`
                  width: 178px;
                  height: 30px;
                  border-radius: 3px;
                  z-index: 10;
                  text-align: center;
                  position: absolute;
                  margin: 4px;

                  @media screen and (max-width: 600px) {
                    width: calc(120px - 8px);
                  }
                `}
                style={{ backgroundColor: "white" }}
              />
            )}
          </motion.div>
        ))}

        <TitleOne onClick={() => handleSelected(GENERAL)}>General</TitleOne>
        <TitleTwo onClick={() => handleSelected(FOOTER)}>Footer</TitleTwo>
        <TitleThree onClick={() => handleSelected(SEND_FROM)}>
          Send From
        </TitleThree>
      </Container>
    </AnimateSharedLayout>
  );
}
